import { render, staticRenderFns } from "./EditCustomer.vue?vue&type=template&id=baf24480&scoped=true&"
import script from "./EditCustomer.vue?vue&type=script&lang=js&"
export * from "./EditCustomer.vue?vue&type=script&lang=js&"
import style0 from "./EditCustomer.vue?vue&type=style&index=0&id=baf24480&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf24480",
  null
  
)

export default component.exports